import React from 'react';

interface TaskCalendarProps {
    fill?: string;
}

export const TaskCalendar = ({ fill = '#757575' }: TaskCalendarProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M12.25 1.16667H10.5V0H9.33333V1.16667H4.66667V0H3.5V1.16667H1.75C1.28587 1.16667 0.840752 1.35104 0.512563 1.67923C0.184374 2.00742 0 2.45254 0 2.91667L0 14H14V2.91667C14 2.45254 13.8156 2.00742 13.4874 1.67923C13.1592 1.35104 12.7141 1.16667 12.25 1.16667ZM1.16667 2.91667C1.16667 2.76196 1.22812 2.61358 1.33752 2.50419C1.44692 2.39479 1.59529 2.33333 1.75 2.33333H12.25C12.4047 2.33333 12.5531 2.39479 12.6625 2.50419C12.7719 2.61358 12.8333 2.76196 12.8333 2.91667V4.66667H1.16667V2.91667ZM1.16667 12.8333V5.83333H12.8333V12.8333H1.16667Z"
                fill={fill}
            />
            <path d="M9.91667 7.58337H8.75V8.75005H9.91667V7.58337Z" fill={fill} />
            <path d="M7.58333 7.58337H6.41666V8.75005H7.58333V7.58337Z" fill={fill} />
            <path d="M5.24999 7.58337H4.08333V8.75005H5.24999V7.58337Z" fill={fill} />
            <path d="M9.91667 9.91663H8.75V11.0833H9.91667V9.91663Z" fill={fill} />
            <path d="M7.58333 9.91663H6.41666V11.0833H7.58333V9.91663Z" fill={fill} />
            <path d="M5.24999 9.91663H4.08333V11.0833H5.24999V9.91663Z" fill={fill} />
        </svg>
    );
};
